<template>
  <div class="border-dark my-5 p-lg-5 p-3">
    <template>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center"></th>
              <td class="text-center b1">{{ $t("card.fileName") }}</td>
              <td class="text-center b1">{{ $t("orderForm.colorType") }}</td>
              <td class="text-center b1">
                {{ $t("orderForm.bookbindingType") }}
              </td>
              <td class="text-center b1">{{ $t("card.numberOfPages") }}</td>
              <td class="text-center b1">{{ $t("orderForm.series") }}</td>
              <td class="text-center b1">{{ $t("card.price") }}</td>
              <td class="text-center b1">{{ $t("card.download") }}</td>
              <td class="b1">{{ $t("card.delete") }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in cartData" :key="item.row">
              <td class="text-center"></td>
              <td class="text-center">{{ item.file_name }}</td>
              <td class="text-center" v-if="item.type == 'BW1'">
                {{ $t("black-white") }}
              </td>
              <td class="text-center" v-if="item.type == 'BW2'">
                {{ $t("both-black-white") }}
              </td>
              <td class="text-center" v-if="item.type == 'RGB1'">
                {{ $t("colorfull") }}
              </td>
              <td class="text-center" v-if="item.type == 'RGB2'">
                {{ $t("both-colorfull") }}
              </td>
              <td class="text-center" v-if="item.bookbinding == 'S'">
                {{ $t("orderForm.bookbinding") }}
              </td>
              <td class="text-center" v-if="item.bookbinding == 'M'">
                {{ $t("orderForm.punch") }}
              </td>
              <td class="text-center" v-if="item.bookbinding == 'N'">
                {{ $t("orderForm.none") }}
              </td>

              <td class="text-center">{{ item.page_number }}</td>
              <td class="text-center">{{ item.print_number }}</td>
              <td class="text-center">{{ item.persian_price }}</td>
              <td class="text-center">
                <a :href="item.file" download
                  ><v-icon>mdi-file-download</v-icon></a
                >
              </td>
              <td>
                <v-icon :id="item.id" @click="deleteRow(item.id)"
                  >mdi-delete</v-icon
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <div class="row b1">
      {{ $t("card.totalPrice") }}
    </div>
    <div class="row greenColor b1">
      {{ totlPrice }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cartData: [],
      totlPrice: "",
    };
  },
  methods: {
    deleteRow(id) {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios
        .delete("order/" + id + "/?cart=" + this.$session.get("newCartid"), {
          data: {
            cart: this.$session.get("newCartid"),
          },
        })
        .then((response) => {
          console.log(response);
          this.axios.defaults.headers.common["Authorization"] =
            "Bearer " + this.$session.get("token");
          this.axios
            .get("order/?cart=" + this.$session.get("newCartid"))
            .then((response) => {
              console.log(response.data[0]);
              this.cartData = response.data[0];
              this.axios
                .get("cart/getprice/" + this.$session.get("newCartid"))
                .then((response) => {
                  console.log(response.data[0]);
                  this.totlPrice = response.data[0] +  this.$t('toman');
                });
            });
        });
    },
  },
  mounted() {
    if (this.$session.get("newCartid")) {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios
        .get("order/?cart=" + this.$session.get("newCartid"))
        .then((response) => {
          console.log(response.data[0]);
          this.cartData = response.data[0];
          // this.orders = response.data[0];

          this.axios
            .get("cart/getprice/" + this.$session.get("newCartid"))
            .then((response) => {
              console.log(response.data[0]);
              this.totlPrice = response.data[0] +  this.$t('toman');
            });
        });
    }
  },
};
</script>
<style scoped>
.greenColor {
  color: #20db9d;
}
table {
  counter-reset: row-num;
}
table tr {
  counter-increment: row-num;
}
table tr td:first-child::before {
  content: counter(row-num);
}
</style>
